import { TimeslotContentResponseDTO } from '../dtos/response/timeslotContent/timeslotContent'
import {
	TimeslotContent,
	TimeslotContentMetadata,
} from '../entities/timeslotContent'
import { PlaylistMapper } from './playlist/playlistMapper'

export class TimeslotContentMapper {
	static toEntity(data: TimeslotContentResponseDTO): TimeslotContent {
		return new TimeslotContent({
			id: data.id,
			timeslotId: data.timeslot_id,
			type: data.type,
			metadata: TimeslotContentMetadata.create({
				volume: data.metadata.volume,
				minPercentage: data.metadata.min_percentage,
				maxPercentage: data.metadata.max_percentage,
			}),
			playlists:
				data.playlists?.data.map((playlist) =>
					PlaylistMapper.toEntity(playlist)
				) || undefined,
		})
	}
}
